import type { IssueWriteRequest } from "contracts/api/issue/requests";
import type { Issue } from "contracts/api/issue/responses";
import {
  ISSUE_EFFORT,
  ISSUE_SEVERITY,
  ISSUE_STATUS,
} from "contracts/enums/core";
import { METRIC_CATALOG } from "contracts/report/catalog";
import { defaultBlock } from "./blockDefaults";

export function toIssueDraft(
  issue: Issue | null,
  defaultMetricKey?: string,
): IssueWriteRequest {
  return issue
    ? {
        title: issue.title,
        metricKey: issue.metricKey,
        severity: issue.severity,
        impact: issue.impact,
        effort: issue.effort,
        status: issue.status,
        ownerName: issue.ownerName,
        ownerInitials: issue.ownerInitials,
        blocks: issue.blocks,
      }
    : {
        title: "New issue",
        metricKey:
          (defaultMetricKey as Issue["metricKey"] | undefined) ??
          METRIC_CATALOG[0].key,
        severity: ISSUE_SEVERITY.MEDIUM,
        impact: 1,
        effort: ISSUE_EFFORT.S,
        status: ISSUE_STATUS.OPEN,
        ownerName: null,
        ownerInitials: null,
        blocks: [defaultBlock()],
      };
}
